module.exports = __webpack_public_path__ + "media/src/images/partners/luiss-ac5aec88d2d561a498c5c9b5fdc10d29.jpg";